"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function OurTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const teamMembers = [{
    id: 1,
    name: "Chukwudi Okoro",
    role: "Founder & CEO",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/chukwudi_okoro_portrait.png"
  }, {
    id: 2,
    name: "Amaka Nwosu",
    role: "Head of Real Estate",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/amaka_nwosu_portrait.png"
  }, {
    id: 3,
    name: "Tunde Adeyemi",
    role: "SEO Director",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/tunde_adeyemi_portrait.png"
  }, {
    id: 4,
    name: "Ngozi Eze",
    role: "Digital Marketing Strategist",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/ngozi_eze_portrait.png"
  }, {
    id: 5,
    name: "Oluwaseun Balogun",
    role: "Investment Analyst",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/oluwaseun_balogun_portrait.png"
  }, {
    id: 6,
    name: "Chidinma Okonkwo",
    role: "Client Relations Manager",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/chidinma_okonkwo_portrait.png"
  }];
  return <section ref={ref} className="bg-background py-16 px-6 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-12 text-center font-display text-4xl font-bold text-foreground lg:text-5xl">
          Our Team
        </h2>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} className={`group relative overflow-hidden border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
          animationDelay: isVisible ? `${i * 250}ms` : "0ms"
        }}>
              <CardContent className="flex flex-col items-center p-0">
                <div className="relative h-64 w-full overflow-hidden">
                  <img src={member.image} alt={member.name} className="h-full w-full rounded-t-xl object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02]" />
                </div>
                <div className="w-full translate-y-0 bg-gradient-to-t from-dark-background/95 to-transparent px-6 py-8 text-center transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:-translate-y-1">
                  <h3 className="mb-1 font-display text-xl font-semibold text-foreground-dark">
                    {member.name}
                  </h3>
                  <p className="text-sm text-muted-foreground">{member.role}</p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}